// extracted by mini-css-extract-plugin
module.exports = {"shadow":"TitleCell_shadow__OrDul","csaTitle":"TitleCell_csaTitle__XqyGR"};